'use client';

import { useTranslations } from 'next-intl';
import PartsDiagramError from '../parts-diagram-error';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';

const EquipmentError = () => {
  const t = useTranslations();
  const { equipmentError } = usePartDiagram();

  return (
    equipmentError && (
      <PartsDiagramError
        errorTitle={t('PARTS_DIAG_API_ERROR_TITLE')}
        errorDesc={t('UNKONWN_ERROR')}
      />
    )
  );
};

export default EquipmentError;
